import axiosInstance from 'src/utils/axios';
import * as Types from './types.api';

//
//

const BASE_URL = 'merchants/v1/invitations';

//

export const getInvitationByIdAPI = async (
  payload: Types.InvitationByIdPayload
): Promise<Types.InvitationResponse> => {
  const { id } = payload;

  const response = await axiosInstance.get<any>(`${BASE_URL}/${id}`);

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};
